import { UIHeading1, UIHeading2, useDeviceType } from '@cian/ui-kit';
import cn from 'clsx';
import React from 'react';

import styles from './styles.css';

export interface ITitleFormProps {
  children: React.ReactElement | null | string;
}

export const TitleForm: React.FC<ITitleFormProps> = ({ children }) => {
  const deviceType = useDeviceType();
  const isDesktop = deviceType === 'desktop';

  const Heading = isDesktop ? UIHeading1 : UIHeading2;

  return (
    <div className={cn(styles.root, styles[deviceType])} data-testid="form-title">
      <Heading>{children}</Heading>
    </div>
  );
};

TitleForm.displayName = 'TitleForm';
